import { t } from "@/i18n-js/instance";

import type { UpgradeAcceptanceBody, UseUpgradeAcceptanceProps } from "./types";

export const buildUpgradeAcceptanceBody = (
  priceId: number | undefined,
  couponMode: UseUpgradeAcceptanceProps["couponMode"],
  previewCouponId: number | null | undefined,
): UpgradeAcceptanceBody => {
  if (!priceId) throw new Error("Upgrade preview is unavailable");
  return {
    session_step: {
      paywall_price_id: priceId,
      coupon_mode: couponMode === "without_coupon" ? "none" : "policy",
      ...(couponMode === "policy" && previewCouponId
        ? { coupon_id: previewCouponId }
        : {}),
    },
  };
};

export const getUpgradeUnresolvedMessage = () =>
  t("paywall_checkout.offer_page.upgrade.status_unresolved");

export const getUpgradePaymentFailureMessage = (
  changeDeferredUntilPayment?: boolean,
) => {
  if (changeDeferredUntilPayment === true) {
    return t("paywall_checkout.offer_page.upgrade.payment_failure_deferred");
  }
  if (changeDeferredUntilPayment === false) {
    return t("paywall_checkout.offer_page.upgrade.payment_failure_applied");
  }
  return t("paywall_checkout.offer_page.upgrade.status_unresolved");
};
